import { Component, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { PlatformLocation } from "@angular/common";

@Component({
    selector: "app-benefits-modal",
    templateUrl: "./benefits-modal.component.html",
    styleUrls: ["./benefits-modal.component.scss"],
    standalone: false,
})
export class BenefitsModalComponent {
    @Input() benefits: string[] = [];

    constructor(
        public activeModal: NgbActiveModal,
        private location: PlatformLocation,
    ) {
        location.onPopState(() => activeModal.close());
    }
}
